import { useGuest } from '@/contexts/GuestContext';
import { Lock } from 'lucide-react';

export function GuestPrice({ children, className = '' }) {
  const guest = useGuest();

  if (guest?.isGuest) {
    return (
      <button
        onClick={() => guest.requireAuth()}
        className={`inline-flex items-center gap-1 text-[#2F80ED] font-semibold text-xs bg-blue-50 px-2 py-1 rounded-lg ${className}`}
        data-testid="guest-price-lock"
      >
        <Lock className="h-3 w-3" />
        Login to see
      </button>
    );
  }

  return <>{children}</>;
}
